<template>
  <div class="cotainer card-item">
    <div class="title-box">
      <span class="title-text">教研情况</span>
      <span class="btn-action-group">
        <!-- v-if="oldInfos?.id && !isEdit"  -->
        <a-button type="primary" @click="addGains" class="btn-action"
          >新增</a-button
        >
        <!-- <a-button
          class="btn-action"
          type="primary"
          v-if="oldInfos?.id "
          @click="showevidence"
        >
        佐证材料</a-button> -->
        <!-- <a-button @click="importsj()" class="btn-action" v-if="oldInfos?.id && !isEdit">导入</a-button> -->
        <a-button class="btn-action" danger type="text" @click="batchDelete">
          批量移除</a-button
        >
      </span>
    </div>
    <div class="cotainerfottter">
      <a-table
        style="text-align: center"
        :locale="{
          emptyText: oldInfos?.id ? '暂无数据' : '填写基本信息之后才能添加内容',
        }"
        :columns="columns"
        :data-source="dataList"
        :loading="loading"
        @change="handleTableChange"
        :pagination="pagination"
        :bordered="true"
        rowKey="id"
        :scroll="{ y: 290 }"
        :row-selection="rowSelection"
      >
        <template slot="sequenceNumber" slot-scope="text, record, index">
          {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
        </template>
        <template slot="sex" slot-scope="text, record, index">
          <span v-if="text == '1'">男</span>
          <span v-else>女</span>
        </template>
        <template slot="izResponse" slot-scope="text, record, index">
          <span v-if="text == '1'">是</span>
          <span v-else>否</span>
        </template>
        <span
          class="flex flex-around"
          slot="action"
          slot-scope="record"
          style="margin: 0 50px"
        >
          <!-- style="margin: 0 50px" -->
          <!-- <div
            class="flex align-items-center"
            style="cursor: pointer"
             v-if="(oldInfos && oldInfos.id && !isEdit)"
            @click="showevidence(record)"
          >
            <img class="img-box" src="../../assets/images/imgcl.png" alt="" />
            <span>佐证材料</span>
          </div> -->
          <!-- v-if="oldInfos?.id && !isEdit" -->
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            @click="editInfo(record)"
          >
            <img class="img-box" src="../../assets/images/img42.png" alt="" />
            <span>编辑</span>
          </div>
          <!-- v-if="oldInfos?.id && !isEdit" -->
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            @click="deleteInfo(record)"
          >
            <img class="img-box" src="../../assets/images/img43.png" alt="" />
            <span>移除</span>
          </div>
        </span>
      </a-table>
    </div>
    <a-modal
      title="您确定移除吗"
      :visible="showDeleteModel"
      ok-text="确认"
      cancel-text="取消"
      @ok="handleOk"
      @cancel="showDeleteModel = false"
    >
      <p>您确定要移除该条教研情况的数据吗?</p>
    </a-modal>
    <!-- 添加老师 -->
    <addTeachRearch ref="addGain" @addGain="addGaincz"></addTeachRearch>
    <data-import ref="dataImport" @refreshData="addGain"></data-import>
    <div class="preview-pop-box" v-if="showtable">
      <div class="preview-boxs">
        <evidencelist
          :title="title"
          :isEdit="isEdit"
          :dataid="sj.id"
          :id="id"
          @closePreview="showtable = false"
        >
        </evidencelist>
      </div>
    </div>
  </div>
</template>
    
<script>
import { getAction, postAction, putAction, deleteAction } from "@/api/index";
import dataImport from "@/components/common/dataImport.vue";
import addTeachRearch from "./addTeachRearch.vue";
import evidencelist from "@/components/common/evidencelist";
const columns = [
  {
    title: "序号",
    dataIndex: "sequenceNumber",
    id: "sequenceNumber",
    align: "center",
    scopedSlots: { customRender: "sequenceNumber" },
    width: 70,
  },
  {
    title: "年份",
    dataIndex: "year",
    id: "year",
    align: "center",
    width: 150,
  },
  {
    title: "次数",
    dataIndex: "num",
    id: "num",
    align: "center",
    // width: 100,
  },
  {
    title: "操作",
    id: "action",
    align: "center",
    width: 300,
    scopedSlots: { customRender: "action" },
  },
];
export default {
  data() {
    return {
      dataList: [],
      loading: false,
      showDeleteModel: false,
      deteleId: "",
      pagination: {
        total: 0,
        current: 1,
        pageSize: 5,
      },
      columns: columns,
      selectedRowKeys: [],
      isEdit: false,
      showtable: false,
      id: "",
      title: "",
      sj: {},
    };
  },
  props: {
    oldInfos: {
      type: Object,
    },
    isbj: {
      type: Boolean,
      defalt: true,
    },
  },
  components: {
    addTeachRearch,
    dataImport,
    evidencelist,
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
        // 其他 row-selection 的配置
      };
    },
  },
  watch: {
    "oldInfos.teachreserchlist": {
      handler(newValue, oldValue) {
        console.log(newValue, "9999999999999999");
        if (newValue != null) {
          if (
            this.$parent.editInfo &&
            this.$parent.editInfo?.type == "preview"
          ) {
            this.isEdit = true;
          }
          this.addGain();
        }
        // console.log(newValue, "8989898989");
      },
      deep: true,
    },
    isbj: {
      handler(newValue, oldValue) {
        // console.log(newValue,'我是')
        this.isEdit = newValue;
      },
      immediate: true,
    },
  },
  mounted() {
    this.isEdit =
      this.$parent.editInfo && this.$parent.editInfo.type == "preview";
    this.getData();
  },
  methods: {
    showevidence(record) {
      this.title = "教研情况";
      this.id = this.oldInfos.id;
      this.sj = record;
      this.showtable = true;
    },
    importsj() {
      this.$refs.dataImport.init(
        "teachingresearchsituation",
        this.oldInfos,
        "教研情况"
      );
    },
    handleOk() {
      this.$message.success("移除成功");
      this.showDeleteModel = false;
      this.oldInfos.teachreserchlist = this.oldInfos.teachreserchlist.filter(
        (item) => item.id != this.deteleId
      );
      sessionStorage.setItem("gzs1", JSON.stringify(this.oldInfos));
      this.getData();
      // deleteAction("/lxbase/lxTeachingResearchSituation/delete", {
      //   id: this.deteleId,
      // }).then((res) => {
      //   if (res.code == 200) {
      //     this.$message.success("移除成功");
      //     this.showDeleteModel = false;
      //     this.getData();
      //   } else {
      //     this.$message.error(res.message);
      //   }
      // });
    },
    addGains() {
      this.$refs.addGain.init("add", this.oldInfos);
    },
    addGaincz(sj) {
      // console.log(sj);
      if (sj.type == "add") {
        this.pagination.current = 1;
        this.oldInfos.teachreserchlist.unshift({
          ...sj.record,
          id: "教研情况" + this.oldInfos.teachreserchlist.length,
        });
      } else {
        let index = this.oldInfos.teachreserchlist.findIndex(
          (item) => item.id === sj.record.id
        );
        // console.log(sj.record.id,this.oldInfos.teachreserchlist);
        if (index !== -1) {
          // 如果找到相同的 id，替换该对象
          this.oldInfos.teachreserchlist[index] = sj.record;
        }
      }
      sessionStorage.setItem("gzs1", JSON.stringify(this.oldInfos));
      // console.log(this.oldInfos.teachreserchlist);
      this.getData();
    },
    addGain() {
      //this.pagination.current = 1;
      this.getData();
    },
    getData() {
      if (this.oldInfos?.id) {
        this.loading = true;
        let data = {
          applyType: 1,
          pageNo: this.pagination.current,
          pageSize: this.pagination.pageSize,
          applyId: this.oldInfos?.id,
        };
        getAction("/lxbase/lxTeachingResearchSituation/list", data).then(
          (res) => {
            if (res.code === 200) {
              let data = res.result.records;
              if (data) {
                this.dataList = data;
                this.pagination.total = res.result.total;
              }
            }
            this.loading = false;
          }
        );
      } else {
        if (
          this.oldInfos &&
          this.oldInfos.teachreserchlist &&
          this.oldInfos.teachreserchlist.length > 0
        ) {
          this.pagination.total = this.oldInfos.teachreserchlist.length;
          const startIndex =
            (this.pagination.current - 1) * this.pagination.pageSize;
          const endIndex = startIndex + this.pagination.pageSize;
          let formatList = this.oldInfos.teachreserchlist.slice(
            startIndex,
            endIndex
          );
          if (formatList.length == 0 && this.pagination.current > 1) {
            this.pagination.current = this.pagination.current - 1;
            const startIndex =
              (this.pagination.current - 1) * this.pagination.pageSize;
            const endIndex = startIndex + this.pagination.pageSize;
            formatList = this.oldInfos.teachreserchlist.slice(
              startIndex,
              endIndex
            );
          }
          this.dataList = formatList;
        } else {
          this.dataList = [];
          this.pagination.total = 0;
          this.pagination.current = 1;
        }
      }
    },
    deleteInfo(row) {
      this.showDeleteModel = true;
      this.deteleId = row.id;
    },
    editInfo(row) {
      this.$refs.addGain.init("edit", row);
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.getData();
    },
    option(type) {
      if (type === 1) {
        this.$emit("upStep", this.dataList);
      } else {
        this.$emit("downStep", this.dataList);
      }
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    batchDelete() {
      // let applyType = 1;
      // if (this.$route.name === "szStudio") {
      //   applyType = 1;
      // } else if (this.$route.name === "educationalBrand") {
      //   applyType = 2;
      // } else {
      //   applyType = 3;
      // }
      if (this.selectedRowKeys.length == "0") {
        this.$message.warning("请选择要批量移除的教研情况");
      } else {
        //this.pagination.current = 1;
        console.log(this.selectedRowKeys);
        this.oldInfos.teachreserchlist = this.oldInfos.teachreserchlist.filter(
          (item) => !this.selectedRowKeys.includes(item.id)
        );
        sessionStorage.setItem("gzs1", JSON.stringify(this.oldInfos));
        this.getData();
        this.selectedRowKeys = [];
        // let params = {
        //   ids: this.selectedRowKeys.toString(),
        // };
        // deleteAction("/lxbase/lxTeachingResearchSituation/deleteBatch", params).then((res) => {
        //   if (res.code == 200) {
        //     this.$message.success("批量移除成功");
        //     this.pagination.current=1;
        //     this.getData();
        //     this.selectedRowKeys = [];
        //     this.$forceUpdate();
        //   } else {
        //     this.$message.error(res.message);
        //   }
        // });
      }
    },
  },
};
</script>
    
<style scoped="scoped" lang="scss">
.cotainer {
  &.card-item {
    background: #ffffff;
    box-shadow: 1px 2px 14px 7px rgba(180, 180, 180, 0.11);
    padding: 37px 20px;
    box-sizing: border-box;
    margin-bottom: 24px;
    .title-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 12px;
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: 700;
      border-bottom: 1px solid #d9d9d9;
      .title-text {
        color: #2155b5;
        font-size: 20px;
        font-weight: bold;
        height: 40px;
        line-height: 40px;
        border-bottom: 3px solid #2155b5;
        padding: 0px 4px;
      }
    }
    .title-boxs {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-bottom: 12px;
      font-size: 20px;
    }
    .btn-action {
      width: 100px;
      height: 30px;
      border-radius: 6px;
      font-weight: 400;
      cursor: pointer;
      line-height: 30px;
      margin-right: 10px;
      text-align: center;
    }
  }
  .cotainerhead {
    margin: 20px 0px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .add-btn {
      width: 100px;
      height: 30px;
      background: #2155b5;
      border-radius: 6px;
      font-weight: 400;
      color: #fff;
      cursor: pointer;
      line-height: 30px;
      margin-right: 10px;
      text-align: center;
    }
  }
}
.img-box {
  width: 18px;
  height: 18px;
  margin-right: 5px;
}
.img-box-preview {
  width: 21px;
  height: 21px;
  margin-right: 9px;
}
.preview-pop-box {
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  .preview-box {
    margin: 50px auto;
    width: 1177px;
    height: 90%;
  }
  .preview-boxs {
    margin: 50px auto;
    width: 950px;
    height: 700px;
    overflow: hidden;
  }
  .preview-box-fullscreen {
    width: 100vw;
    height: 100vh;
  }
}
</style>